import "./CoursesStyle.css";


const Courses= () =>{return(
    <div className="courses-gral">
        <div className="courses-interna">
            <a  style ={{textDecoration:'none'}} className="" href="https://greentecher.com/MACHIDESCUENTO/?ref=Tom.arguello&campaign=Machi" target= "_blanck">
                 <img className="imgCourses" src="https://www.debrown.com.ar/wp-content/uploads/2020/09/huerta-org%C3%A1nica-2020-1.jpg" alt="la futura imagen"/>
                 <div className='courses-texto'><p>CAPACITACION Y CURSOS</p></div>
            </a>
        </div>

    </div>
    )
}

export default Courses